/* eslint-disable react/no-unused-prop-types */
/* note: the above suppression is because our FormatWrapper component does not directly use the props but uses object spread, and the intellisense is not intelligent enough */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedNumber} from 'react-intl';
import Immutable from 'immutable';
import BillingRow from 'accountComponents/BillingRow';
import { toastr } from "react-redux-toastr";
import { OptimizationStatusConfig } from '../../constants/optimizationStatusConfig';
import { isFiberOrCommercial } from '../../utils/accountUtils';

const FormatWrapper = (props) => {
  if (props.formatter === 'currency' && props.value) {
    return <FormattedNumber {...props} />;
  }

  if (props.formatter === 'date' && props.value) {
    return <FormattedDate {...props} />;
  }

  if (props.formatter === "ecid" && props.value) {
    return (
      <span>
        {props.value}
        <button
          style={props.styles}
          onClick={() => {
            navigator.clipboard.writeText(props.value);
            toastr.success("ECID Copied to Clipboard");
          }}
        >
          {String.fromCharCode(
            parseInt(props.unicodeChar.replace("&#x", ""), 16)
          )}
        </button>
      </span>
    );
  }

  return <span>N/A</span>;
};

const HalfColumn = (props) =>
  {
    const matchedColumnsSet = props.columnDataSet.filter(
      (item) => item.column === props.column
    );

    return (
      <div className="col s6 m6 l6">
        {matchedColumnsSet.map((r, i) => (
          <BillingRow label={r.label} key={"billing-row-" + i}>
            {r.formatterWrapperProps ? (
              <FormatWrapper
                value={r.data}
                {...r.formatterWrapperProps}
              />
            ) : (
              r.data
            )}
          </BillingRow>
        ))}
      </div>
    );
  };

HalfColumn.propTypes = {
  columnDataSet: PropTypes.array,
  column: PropTypes.number
};



FormatWrapper.propTypes = {
  formatter: PropTypes.string.isRequired,
  value: PropTypes.any,
  style: PropTypes.string,
  currency: PropTypes.string,
  year: PropTypes.string,
  month: PropTypes.string,
  day: PropTypes.string
};

const BillingPanel = (props) => {
    const {
      orderDetails,
      billingInfo,
      customerInfo,
      collectionInfo,
      outletOptimizationDetails
    } = props;

    if (!billingInfo && !customerInfo) {
        return (
            <h6 className="padx2">
                No Account Information Found
            </h6>
        );
    }

    const billing = billingInfo || new Immutable.Map();
    const collections = collectionInfo || new Immutable.Map();
    const customer = customerInfo || new Immutable.Map();
    const orderDets = orderDetails || new Immutable.Map();
    const outletOptimization = outletOptimizationDetails || new Immutable.Map();

    const currencyFormatConfig = {
      formatter: "currency",
      style: "currency",
      currency: "USD",
    };

    const dateFormatConfig = {
      formatter: "date",
      year: "2-digit",
      month: "2-digit",
      day: "2-digit"
    };

    const ecidConfig = {
      formatter: "ecid",
      unicodeChar: "&#xf0c5;",
      styles: {
        fontFamily: "FontAwesome",
        border: 0,
        background: "none",
        marginLeft: "5px",
        fontSize: "large",
      },
    };

    let columnDataSet = [
      {
        label: "Account Number",
        data: customer.get("accountNumber"),
        column: 1,
      },
      {
        label: "House Number",
        data: orderDets.get("addressId"),
        column: 1,
      },
      {
        label: "Current Balance",
        data: billing.get("currentBalance") || "0.00",
        column: 1,
        formatterWrapperProps: currencyFormatConfig,
      },
      {
        label: "Past Due Amount",
        data: billing.get("pastDueAmount"),
        column: 1,
        formatterWrapperProps: currencyFormatConfig,
      },
      {
        label: "Last Payment Date",
        data: billing.get("lastPaymentDate"),
        column: 1,
        formatterWrapperProps: dateFormatConfig,
      },
      {
        label: "ECID",
        data: customer.get("ecid"),
        column: 2,
        formatterWrapperProps: ecidConfig,
      }, {
        label: "Collection Status",
        data: collections.get("collectionStatus") || "N/A",
        column: 2,
      },
      {
        label: "Has Non-Pay",
        data: collections.get("hasNonPay") ? "Yes" : "No",
        column: 2,
      },
      {
        label: "Promise Date",
        data: collections.get("promiseDate"),
        column: 2,
        formatterWrapperProps: dateFormatConfig,
      },
      {
        label: "Promise Amount",
        data: collections.get('promiseAmount') || "0.00",
        column: 2,
        formatterWrapperProps: currencyFormatConfig,
      },
    ];

    //Do not show OutletOptimizationStatus for Commercial or  Fiber accounts
    if(!isFiberOrCommercial(customer.get("signalAccessCode"), customer.get("customerType"))) {


        const outletOptimizationStatus = outletOptimization
        ? outletOptimization.get("outletOptimizationStatus")
        : null;
        const status = OptimizationStatusConfig.find(
          (m) => m.value === outletOptimizationStatus
        );

        const outletOptimizationMember = {
          label: "Outlet Optimization Status",
          data: status ? status.message : "Not Assessed",
        column: 1,
        };
        columnDataSet.push(outletOptimizationMember);
    }

    return (
        <div className="padx2 text-align-left">
            <div className="row">
              <HalfColumn columnDataSet={columnDataSet} column={1}/>
              <HalfColumn columnDataSet={columnDataSet} column={2}/>
            </div>
        </div>
    );
};

BillingPanel.propTypes = {
    orderDetails: PropTypes.object,
    billingInfo: PropTypes.object,
    customerInfo: PropTypes.object,
    collectionInfo: PropTypes.object
};

export default BillingPanel;



// WEBPACK FOOTER //
// ./src/components/account/BillingPanel.js